import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useIsSuspendedQuery = () => {
  const query = useQuery({
    queryKey: [QueryKeys.SUSPENDED],
    queryFn: accountRepo.getIsSuspended,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};
